export default __webpack_public_path__ + "static/media/chevron-right.c66f6e03.svg";